import {
    AvailablePlanStatus,
    AvailablePlanType,
    CalculatorResultType,
    LegalGender,
} from "@common-shared/config/coverage.config"

export const COMMON_ONE_VERIFY_CHECKER_CONFIG = {
    get activeCoverageResults(): CalculatorResultType[] {
        return [
            CalculatorResultType.activeCoverage,
            CalculatorResultType.activePartialCoverage,
        ]
    },

    get calculatorResultTypeTitleMapping(): Record<
        CalculatorResultType,
        string
    > {
        return {
            [CalculatorResultType.activeCoverage]: "Active",
            [CalculatorResultType.activePartialCoverage]:
                "Active - Partial Data",

            [CalculatorResultType.noCoverage]: "Inactive",

            [CalculatorResultType.activePlanCoverageUnknown]:
                "Unknown Coverage Status",
            [CalculatorResultType.unknownPlanStatus]: "Unknown Plan Status",
            [CalculatorResultType.generalError]: "API Error",
            [CalculatorResultType.memberNotFound]: "Member Not Found",
            [CalculatorResultType.connectionIssue]: "Failed Connection",
            [CalculatorResultType.payerNotSupported]: "Payer Not Supported",
            [CalculatorResultType.providerNotRecognized]:
                "Provider Not Recognized",
            [CalculatorResultType.errorRetrievingCoverage]:
                "Error Retrieving Coverage",
            [CalculatorResultType.memberIdPayerIdInvalid]:
                "Member ID With a Different Payer",
            [CalculatorResultType.invalidInput]: "Invalid Data Format",
            [CalculatorResultType.unexpectedError]: "Unexpected Error",
            [CalculatorResultType.tooManyRequests]: "Too Many Requests",
            [CalculatorResultType.payerFailure]: "Payer Failure",
        }
    },

    get genderMapping(): Record<LegalGender, string> {
        return {
            [LegalGender.male]: "Male",
            [LegalGender.female]: "Female",
        }
    },

    get planTypeMapping(): Record<AvailablePlanType, string> {
        return {
            [AvailablePlanType.COMMERCIAL]: "Commercial",
            [AvailablePlanType.DUAL]: "Dual",
            [AvailablePlanType.EMPLOYEE_ASSISTANCE_PROGRAM]:
                "Employee Assistance Program",
            [AvailablePlanType.GOVERNMENT]: "Government",
            [AvailablePlanType.MARKETPLACE]: "Marketplace",
            [AvailablePlanType.ORIGINAL_MEDICAID]: "Original Medicaid",
            [AvailablePlanType.MANAGED_MEDICAID]: "Managed Medicaid",
            [AvailablePlanType.MEDICARE_ADVANTAGE]: "Medicare Advantage",
            [AvailablePlanType.ORIGINAL_MEDICARE]: "Original Medicare",
            [AvailablePlanType.SUPPLEMENTAL_MEDICARE]: "Supplemental Medicare",
            [AvailablePlanType.UNKNOWN]: "Unknown",
            [AvailablePlanType.VETERANS_AFFAIRS]: "Veterans Affairs",
            [AvailablePlanType.NOT_APPLICABLE]: "N/A",
        }
    },

    get activePlanStatuses(): AvailablePlanStatus[] {
        return [AvailablePlanStatus.activeAtRisk, AvailablePlanStatus.active]
    },
}
